<template v-if="entity">
  <BaseButtonElement
    v-bind="{...$props, ...$attrs}"
    :handle-custom-click="openEditCollectionModal"
  />

  <CollectionCreateUpdateModal
    v-if="openModal"
    :open="openModal"
    :collection="entity"
    @close="closeEditCollectionModal"
    @save="updateCollectionEntity"
  />
</template>

<script>
import {
  CollectionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-collection-card/collection-card-element-mixin";
import CollectionCreateUpdateModal from "%/dynamic-component-editor/components/CollectionCreateUpdateModal.vue";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

export default {
  name: "EditCollectionButton",
  components: { BaseButtonElement, CollectionCreateUpdateModal },
  extends: BaseButtonElement,
  mixins: [CollectionCardElementMixin],
  inheritAttrs: false,
  elementPanelSettings: {
    displayName: "Edit Collection",
    elementGroup: "collectionElements",
  },
  data() {
    return {
      openModal: false,
    };
  },
  methods: {
    openEditCollectionModal() {
      this.openModal = true;
    },
    closeEditCollectionModal() {
      this.openModal = false;
    },
    updateCollectionEntity() {
      this.getEntity();
    },
  },
};
</script>
